@if (formReady) {
  <div [formGroup]="form">
    <div class="grid-container wider margin-top">
      <div class="grid-x margin-top">
        <div class="cell small-12 medium-12 large-12">
          <span class="bold">Upload Bulk API NAD83 Updates<span [ngClass]="{ 'red': form?.get('files')?.invalid }">*</span>:</span>
          <upload-view-files [uniqueId]="'files'" [allowUpload]="fileCtrl?.enabled" [files]="files" [componentLabel]="''" [showFileList]="true" [allowDeletion]="allowFileDeletion" (fileRemoved)="fileRemoved($event)" (newFilesList)="fileAdded($event)"></upload-view-files>
        </div>
        @if (!isParsing) {
          @if (hasFileListing) {
            <div class="cell small-12 medium-12 large-12">
              <span class="bold">Parsed API NAD83 Updates:</span>
              <ag-grid-angular class="data-grid " [gridOptions]="parsedGridOptions" [rowData]="data" [statusBar]="statusBar" aria-label="Upload Nad83 Updates"></ag-grid-angular>
            </div>
            <div class="cell small-12 medium-12 large-12">
              <span class="bold">Parsing Errors:</span>
              <ag-grid-angular class="data-grid " [gridOptions]="errorGridOptions" [rowData]="errors" [statusBar]="statusBar" aria-label="Upload Nad83 Updates"></ag-grid-angular>
            </div>
          }
        } @else {
          <div class="cell large-12 medium-12 small-12">
            <text-loader [run]="isParsing && hasFileListing" [text]="'Reading File'" [interval]="500" [tickType]="'.'"></text-loader>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="grid-container wider margin-top">
    <div class="grid-x">
      <div class="cell large-12 medium-12 small-12">
        <text-loader [run]="formReady == false" [interval]="1000" [text]="'Loading application data'" [tickType]="'.'"></text-loader>
      </div>
    </div>
  </div>
}
<a style="display:none;" #downloadLink></a>



